import "./index.less";

export interface IPanelTitleTipProps {
  className?: string;
  title: string;
}

const PanelTitleTip: React.FC<IPanelTitleTipProps> = ({ className, title }) => {
  return (
    <div className={`relative mb-2.5 flex items-center h-6 text-3.5 text-mx-secondary font-500 ${className}`}>
      {title}
      <div className="absolute left-0 bottom-0.5 w-7 h-1.5 title-bg rounded-25"></div>
    </div>
  );
};

export default PanelTitleTip;
